// A dropped File is not serializable, so it can't live in Redux. The search bar
// stashes it here and opens the sidebar; the sidebar (which owns the assistant
// session) takes it once connected and uploads it. Redux carries only a
// serializable token (see AssistantState.pendingAttachmentToken) to signal that a
// file is waiting.

let pendingFile: File | null = null;

export const setPendingAttachmentFile = (file: File | null): void => {
  pendingFile = file;
};

export const takePendingAttachmentFile = (): File | null => {
  const file = pendingFile;
  pendingFile = null;
  return file;
};
